import React from 'react'
import styled from 'styled-components'

const CircleContainer = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Svg = styled.svg`
  transform: rotate(-90deg);
  overflow: visible;
`

const CircleBackground = styled.circle<{ strokeWidth: number }>`
  fill: none;
  stroke: ${({ theme }) => theme.backgroundOutline};
  stroke-width: ${({ strokeWidth }) => strokeWidth}px;
`

const CircleProgress = styled.circle<{ strokeWidth: number; dashArray: number; dashOffset: number; color?: string }>`
  fill: none;
  stroke: ${({ theme, color }) => color || theme.accentActive};
  stroke-width: ${({ strokeWidth }) => strokeWidth}px;
  stroke-dasharray: ${({ dashArray }) => dashArray};
  stroke-dashoffset: ${({ dashOffset }) => dashOffset};
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s ease-in-out;
`

const ChildrenContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

interface CircularProgressProps {
  size?: number
  strokeWidth?: number
  percentage: number
  color?: string
  children?: React.ReactNode
}

export default function CircularProgress({
  size = 40,
  strokeWidth = 4,
  percentage,
  color,
  children,
}: CircularProgressProps) {
  const radius = (size - strokeWidth) / 2
  const circumference = radius * 2 * Math.PI
  const dashOffset = circumference - (percentage / 100) * circumference

  return (
    <CircleContainer size={size}>
      <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <CircleBackground cx={size / 2} cy={size / 2} r={radius} strokeWidth={strokeWidth} />
        <CircleProgress
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          dashArray={circumference}
          dashOffset={dashOffset}
          color={color}
        />
      </Svg>
      {children && <ChildrenContainer>{children}</ChildrenContainer>}
    </CircleContainer>
  )
}
